import { PaginatedApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import {
  ActivityLogQueryParams,
  ActivityLogResponse,
} from "@/types/audit-logs.types";

export const AuditLogService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivityLogs: builder.query<
      PaginatedApiResponse<ActivityLogResponse>,
      ActivityLogQueryParams
    >({
      query: (params) => ({
        url: "activity-logs",
        method: "GET",
        params,
      }),
      transformResponse: (
        response: PaginatedApiResponse<ActivityLogResponse>,
      ) => response,
      providesTags: ["ActivityLogs"],
    }),

    setExportControl: builder.mutation<
      { status: boolean; message: string },
      { is_export_disabled: boolean; reason?: string }
    >({
      query: (body) => ({
        url: "export-control/set",
        method: "POST",
        data: body,
      }),
    }),

    getExportControlStatus: builder.query<
      { is_export_disabled: boolean; reason: string | null },
      void
    >({
      query: () => ({
        url: "export-control/status",
        method: "GET",
      }),
    }),

    exportActivityLogsCsv: builder.query<
      { fileUrl: string },
      Omit<ActivityLogQueryParams, "page" | "limit">
    >({
      query: (params) => ({
        url: "/activity-logs/export/csv",
        method: "GET",
        params,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetActivityLogsQuery,
  useSetExportControlMutation,
  useGetExportControlStatusQuery,
  useExportActivityLogsCsvQuery,
} = AuditLogService;
